import { ReactElement } from 'react';
import classNames from 'classnames';

import { icon_arrow_right } from '@gn-audio/icons';

import { useFallbackTranslation } from '../../../utils/hooks';
import { Button } from '../../Button/Button';
import { JabraFocusItem } from '../../JabraFocus';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { ScopedStyle } from '../../ScopedStyle/ScopedStyle';
import { MajorLinkBigCard } from '../megaMenuTypes';
import { getBgBasedColor, getRandomBGColor } from '../megaMenuUtils';
import { BackgroundImage } from './BackgroundImage';

import styles from './Cards.module.css';

export const BigCard = ({ card }: { card: MajorLinkBigCard }): ReactElement | null => {
  const { t } = useFallbackTranslation();

  const isBackgroundImageSet =
    !!card.BackgroundImage?.value?.src || !!card.backgroundImageExternalLink?.value?.href;

  const bgColor = isBackgroundImageSet ? 'big-photo' : getRandomBGColor(card.id);
  const textColor = getBgBasedColor(bgColor);

  return (
    <>
      {!!card.Link?.value && (
        <ScopedStyle
          id={card.id}
          css={card.Style?.value || ''}
          renderItem={(styleLinkingProp) => (
            <JabraFocusItem asChild>
              <a
                href={card.Link?.value?.href}
                className={classNames(
                  'group relative col-span-1 min-h-[460px] hover:no-underline',
                  `${styles.card} ${styles.bigCard} ${bgColor} ${textColor}`
                )}
                {...styleLinkingProp}
              >
                <div className="absolute inset-0 z-10 bg-gradient-to-t from-[rgba(0,0,0,0.5)] via-[rgba(0,0,0,0.5)] to-60%" />
                {isBackgroundImageSet && (
                  <BackgroundImage
                    field={card.BackgroundImage}
                    externalField={{
                      src: card.backgroundImageExternalLink?.value?.href,
                      altText: card.Header?.value,
                    }}
                    cardType="big"
                  />
                )}
                <div className="relative z-20 w-full">
                  <div className="absolute -bottom-[1.5rem] -left-[1.5rem] h-[calc(100%+3rem)] w-[calc(100%+3rem)] -translate-x-full rounded-r-full bg-blue-800 opacity-90 transition-transform duration-300 group-hover:translate-x-0" />
                  <div className="relative flex-col">
                    <p className={`${styles.header}`}>{card.Header?.value}</p>
                    <p
                      className={`${styles.description}`}
                      dangerouslySetInnerHTML={{ __html: card.Description?.value }}
                    />
                    <Button
                      variant="primary"
                      size="m"
                      aria-label={t('topmenu.ArrowRight')}
                      icon={<JabraIcon className="size-5" Icon={icon_arrow_right} />}
                      noKeyboard
                    />
                  </div>
                </div>
              </a>
            </JabraFocusItem>
          )}
        />
      )}
    </>
  );
};
